module.exports = __webpack_public_path__ + "img/text-logo.05941d2f.svg";